<template>
    <div id="app">
      <TopBar v-on:translationRequested="setLanguage" v-on:storePreviousLanguage="setSource"/>
      <Form :sourceLanguage="sourceLanguage" :targetLanguage="targetLanguage"/>
    </div>
</template>

<script>
import Form from './components/Form';
import TopBar from './components/TopBar';
import { config } from './constants.js';

export default {
    name: 'App',
    components: {
      Form,
      TopBar
    },
    data() {
      return {
        sourceLanguage: {},
        targetLanguage: {},
        showModal: false,
        config
      }
    },
    methods: {
      setLanguage(targetLanguage) {
        this.targetLanguage = targetLanguage
      },
      setSource(previous) {
        this.sourceLanguage = previous
      }
    }
}
</script>

<style>
    #app {
        display: grid;
        justify-items: center;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        font-size: 1.2rem;
        min-height: 100vh;
        background: var(--backgroundUrl);
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    body {
      margin: 0;
      font-size: 62.5%;
    }
    input:focus,
    select:focus,
    textarea:focus,
    button:focus {
        outline: none;
        text-decoration: none;
    }
</style>
<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */

</style>
